import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './styles/blog.css'
import './styles/admin.css'

const app = createApp(App)
app.use(createPinia())
app.use(router)
// 等初始路由解析完成再挂载，避免根组件 onMounted 在导航完成前读到空路由
// （否则 App.vue 里消费 OAuth 回调 token 时 route.query 为空，token 不会被消费）
router.isReady().then(() => app.mount('#app'))
